'use client';
import { SessionProvider } from 'next-auth/react';
import { PreferencesProvider } from '@/lib/preferences';
import { HtmlDirSync } from './HtmlDirSync';
import { ReactNode } from 'react';

export function Providers({ children }: { children: ReactNode }) {
  return (
    <SessionProvider>
      <PreferencesProvider>
        <HtmlDirSync />
        {children}
      </PreferencesProvider>
    </SessionProvider>
  );
}
